<template>
  <!-- 4-n -->
  <q-section v-bind="$attrs">
    <!--  与活动页 document 滚动一致：不在榜单内再套 scroll-y + 定高，避免「区域滚动」 -->
    <van-list style="width: 100%">
      <q-section
        v-for="(item, index) in props.listother"
        :bg-i="item.bg"
        p="relative"
        mb="10"
        bgS="contain"
        bgP="center"
        bgR="no-repeat">
        <q-section
          v-if="item.buff_duration"
          :bg-i="item.buffBg"
          v-bind="item.buffPosition"
          class="flex flex-col items-start justify-center">
          {{ item.buff_ratio + '倍加速中' + item.buff_duration + '分钟' }}
        </q-section>
        <q-section
          :bg-i="isRoomRank ? item.cover_url : item.avatar_url"
          v-bind="item.avatarPosition"
          @click="isRoomRank ? handleRoomClick(item.room.room_id) : handleAvatarClick(item.user.user_id)"></q-section>
        <q-section v-bind="item.nicknamePosition" class="text-left text-nowrap ellipsis">
          {{ isRoomRank ? item.room?.room_title : item.user?.nickname }}
        </q-section>
        <q-section v-bind="item.scorePosition" class="text-center text-nowrap">
          {{ item[item.scoreType] }}
        </q-section>
        <q-section v-bind="item.unitPosition" class="text-center text-nowrap">
          {{ item.unit }}
        </q-section>
        <q-section v-bind="item.rankPosition" class="flex flex-row justify-center items-center">
          {{ isRoomRank ? index + 1 : index + 4 }}
        </q-section>
      </q-section>
    </van-list>
  </q-section>
</template>

<script setup lang="ts">
const props = defineProps<{
  listother: any[]
  isRoomRank: boolean
}>()

console.log('listother-------_>', props.listother)

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
  (e: 'roomClick', roomId: string): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}

const handleRoomClick = (roomId: string) => {
  emit('roomClick', roomId)
}
</script>

<style scoped lang="scss">
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
